import Footer1 from "./Footer1";
import Footer2 from "./Footer2";

const footers = {
    1: Footer1,
    2: Footer2
};

export default footers;